import { Flex } from 'antd'

import { Logo } from '../../styles'

interface CardItemSliderProps {
  logoSrc: string
  setIsPaused: (state: boolean) => void
}

const CardItemSlider: React.FC<CardItemSliderProps> = ({ logoSrc, setIsPaused }) => (
  <Flex
    align="center"
    style={{
      borderRadius: '9.61px',
      backgroundColor: '#ffffff',
      height: '171px',
      paddingInline: '20px',
      cursor: 'pointer',
    }}
    onMouseEnter={() => setIsPaused(true)}
    onMouseLeave={() => setIsPaused(false)}
  >
    <Logo src={logoSrc} alt="client logo" height="70" />
  </Flex>
)
export default CardItemSlider
